import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { ModelEntityType } from '@upright/common/model/input/types';
import { Valence } from '@upright/common/model/types';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { GhgText } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/notes/comparison-notes/ghg';
import { JobsText } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/notes/comparison-notes/jobs';
import { KBLink, KBUrl } from '@upright/ui/common/upright/kb-urls';

export function ComparisonFigureNotes() {
  const context = useNetImpactLensContext();
  const selection = context?.state;
  const valence = selection?.valence;
  const impact = selection?.impact;

  const companyId = context?.data?.entity?.type === ModelEntityType.COMPANY ? context.data.entity.id : undefined;

  if (impact === ImpactCategoryId.GHG_EMISSIONS && valence === Valence.NEGATIVE) {
    return <GhgText companyId={companyId} />;
  } else if (impact === ImpactCategoryId.SCARCE_HUMAN_CAPITAL) {
    return (
      <>
        <div>
          Upright considers the use of highly educated people, i.e. scarce human capital as a resource, similar to
          environmental resources. Therefore, companies using high amounts of highly educated people must create
          sufficient positive impacts to justify use of this resource.
        </div>
        <div style={{ marginTop: '1.0em', marginBottom: '1.0em' }}>
          Note also that Upright considers scarce human capital used in all parts of the company's value chain. This
          means that for a particular company, some of its scarce human capital will be attributed <em>to</em> other
          companies. Similarily, it will also be attributed scarce human capital <em>from</em> other companies. For this
          reason, the number should not be expected to match companies' internal figures on highly educated workforce
          employed.
        </div>
        <KBLink href={KBUrl.ATTRIBUTION} target="_blank">
          Read more on impact attribution
        </KBLink>
      </>
    );
  } else if (impact === ImpactCategoryId.JOBS) {
    return <JobsText companyId={companyId} />;
  } else {
    // TODO: tailor example for different impact categories
    return (
      <>
        <p>
          To avoid double-counting, impacts are attributed across the value chain once and only once. For this reason,
          the impact of a hypothetical company producing, for example, 1,000 refugee shelters per year will not be equal
          to 1,000 refugee shelters, as a significant part of the impact will be attributed to companies in its value
          chain and possibly other companies that enable its activities.
        </p>
        <p>
          <KBLink href={KBUrl.ATTRIBUTION_ILLUSTRATIVE_GHG_EXAMPLE} target="_blank">
            Read more on attribution
          </KBLink>
        </p>
      </>
    );
  }
}
